import './datepicker/datepicker-tr.js';
import './parsley/tr.js';
import './languageformat/languageformat.js';
